import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import HowItWorks from "@/components/HowItWorks";
import WhyWowSection from "@/components/WhyWowSection";
import AudioDemoSection from "@/components/AudioDemoSection";
import UseCasesSection from "@/components/UseCasesSection";
import ReviewsSection from "@/components/ReviewsSection";
import GuaranteeSection from "@/components/GuaranteeSection";
import FAQSection from "@/components/FAQSection";
import SEOTextSection from "@/components/SEOTextSection";
import Footer from "@/components/Footer";
import FloatingCTA from "@/components/FloatingCTA";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <HeroSection />
        <HowItWorks />
        <WhyWowSection />
        <AudioDemoSection />
        <UseCasesSection />
        <ReviewsSection />
        <GuaranteeSection />
        <FAQSection />
        <SEOTextSection />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
};

export default Index;
